import { useMemo } from 'react';

export const tenants = {
  default: {
    id: 'default',
    name: 'Sommelier Agora',
    logo: null,
    colors: {
      primary: '#C9A961',
      secondary: '#1a1625',
    },
    subdomain: null,
  },
  marmoreio: {
    id: 'marmoreio',
    name: 'Marmoreio',
    logo: '/images/tenants/logo-marmoreio.png',
    colors: {
      primary: '#C9A961',
      secondary: '#1a1625',
    },
    subdomain: 'marmoreio',
  },
  adegapremium: {
    id: 'adegapremium',
    name: 'Adega Premium',
    logo: '/images/tenants/adegapremium-logo.png',
    colors: {
      primary: '#B8860B',
      secondary: '#2a1a1a',
    },
    subdomain: 'adegapremium',
  },
};

export const resolvePublicAssetUrl = (assetPath) => {
  if (!assetPath) {
    return null;
  }
  if (assetPath.startsWith('http://') || assetPath.startsWith('https://')) {
    return assetPath;
  }
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const path = assetPath.startsWith('/') ? assetPath : `/${assetPath}`;
  return `${base}${path}`;
};

const persistTenant = (tenantId) => {
  if (!tenantId || tenantId === 'default' || !tenants[tenantId]) {
    return;
  }
  try {
    localStorage.setItem('selectedTenant', tenantId);
  } catch {
    // localStorage indisponível
  }
};

const DEV_SUBDOMAINS = ['localhost', 'www', '127', '0'];

const detectFromSubdomain = () => {
  const enableSubdomain = process.env.REACT_APP_ENABLE_SUBDOMAIN !== 'false';
  if (!enableSubdomain) {
    return null;
  }

  const subdomain = window.location.hostname.split('.')[0];
  if (DEV_SUBDOMAINS.includes(subdomain)) {
    return null;
  }

  return Object.values(tenants).find((tenant) => tenant.subdomain === subdomain) || null;
};

const detectFromUrlParam = () => {
  const tenantParam = new URLSearchParams(window.location.search).get('tenant');
  if (!tenantParam || !tenants[tenantParam]) {
    return null;
  }
  return tenants[tenantParam];
};

const detectFromStorage = () => {
  const savedTenant = localStorage.getItem('selectedTenant');
  if (!savedTenant || !tenants[savedTenant]) {
    return null;
  }
  return tenants[savedTenant];
};

const detectDefaultTenant = () => {
  const defaultTenantId = process.env.REACT_APP_DEFAULT_TENANT || 'default';
  return tenants[defaultTenantId] || tenants.default;
};

export const detectTenant = () => {
  const forcedTenant = process.env.REACT_APP_FORCE_TENANT;
  if (forcedTenant && tenants[forcedTenant]) {
    persistTenant(forcedTenant);
    return tenants[forcedTenant];
  }

  const fromSubdomain = detectFromSubdomain();
  if (fromSubdomain) {
    persistTenant(fromSubdomain.id);
    return fromSubdomain;
  }

  const fromUrl = detectFromUrlParam();
  if (fromUrl) {
    persistTenant(fromUrl.id);
    return fromUrl;
  }

  const fromStorage = detectFromStorage();
  if (fromStorage) {
    return fromStorage;
  }

  const tenant = detectDefaultTenant();
  if (tenant.id !== 'default') {
    persistTenant(tenant.id);
  }
  return tenant;
};

export const useTenant = () => {
  return useMemo(() => detectTenant(), []);
};

export const getAllTenants = () => Object.values(tenants);

export const tenantExists = (tenantId) => !!tenants[tenantId];
